import { Paginated } from '../../common/pagination.js';
import { CreatePromotionInput, EstimateQuery, PromotionEstimate, PromotionListQuery, PromotionView, } from '../../promotion.js';
export const promotionRoutes = {
    estimate: {
        method: 'GET',
        path: '/promotions/estimate',
        query: EstimateQuery,
        response: PromotionEstimate,
    },
    create: {
        method: 'POST',
        path: '/promotions',
        body: CreatePromotionInput,
        response: PromotionView,
    },
    mine: {
        method: 'GET',
        path: '/me/promotions',
        query: PromotionListQuery,
        response: Paginated(PromotionView),
    },
    get: { method: 'GET', path: '/promotions/:promotionId', response: PromotionView },
    /** Cancel an ongoing promotion; unspent budget refunded pro rata (Q-07 resolved: refund unspent). */
    cancel: { method: 'DELETE', path: '/promotions/:promotionId', response: PromotionView },
};
//# sourceMappingURL=routes.js.map